import type { RecommendationDisableToggleButtonProps } from "./recommendation-disable-toggle-button.type";

import { DeleteOutlined, StopOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { useObservationUpdate } from "@/entities/observation";

const RecommendationDisableToggleButton = ({
  observationId,
  action,
  isIconButton = false,
  buttonProps = {},
}: RecommendationDisableToggleButtonProps) => {
  const { t } = useTranslation();
  const { updateObservation, isPending: isLoading } =
    useObservationUpdate(observationId);

  const isEnableAction = action === "enable";

  const onClick = () => {
    const value = isEnableAction ? false : true;
    updateObservation({ needs_recommendation: value });
  };

  const title = t(`recommendation:noRecommendations.${action}.title`);
  const label = t(`recommendation:noRecommendations.${action}.label`);

  const commonProps = {
    ...buttonProps,
    title,
    ["aria-label"]: title,
    icon: isEnableAction ? <StopOutlined /> : <DeleteOutlined />,
    loading: isLoading,
    onClick,
  };

  if (isIconButton) {
    return (
      <Tooltip title={title}>
        <Button {...commonProps} />
      </Tooltip>
    );
  }

  return <Button {...commonProps}>{label}</Button>;
};

export default RecommendationDisableToggleButton;
